import dynamic from "next/dynamic";

export const ContentSideImage_001 = dynamic(() => import("./component"));
